import { render, staticRenderFns } from "./ksAssetItem.vue?vue&type=template&id=1231b9ad&scoped=true&"
import script from "./ksAssetItem.vue?vue&type=script&lang=js&"
export * from "./ksAssetItem.vue?vue&type=script&lang=js&"
import style0 from "./ksAssetItem.vue?vue&type=style&index=0&id=1231b9ad&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231b9ad",
  null
  
)

export default component.exports